export default __webpack_public_path__ + "static/media/Instagram.c050ff81.svg";